import e from "@dialpad/dialtone-tokens/layered/themes/tokens-133-colors.css?inline";
//#region themes/133.js
var t = { brand: {
	css: e,
	name: "133"
} };
//#endregion
export { t as default };
